import Vue from 'vue';
import VueRouter from 'vue-router';
import myActivity from '../../../store/modules/myActivity';

Vue.use(VueRouter);

const routes = [
  {
    path: '/myActivity/index',
    name: 'myActivity',
    component: () => import('@/sub-app/myActivity/pages/index.vue'),
    meta: {
      title: '活动列表',
      keepAlive: false,
    },
  },
  {
    path: '/myActivity/myActivityFocus',
    name: 'myActivityFocus',
    component: () => import('@/sub-app/myActivity/pages/myActivityFocus.vue'),
    meta: {
      title: '活动列表',
      keepAlive: false,
    },
  },
  {
    path: '/myActivity/myActivitySignUp',
    name: 'myActivitySignUp',
    component: () => import('@/sub-app/myActivity/pages/myActivitySignUp.vue'),
    meta: {
      title: '活动列表',
      keepAlive: false,
    },
  },
  {
    path: '/myActivity/details',
    name: 'details',
    component: () => import('@/sub-app/myActivity/pages/details.vue'),
    meta: {
      title: '活动详情',
      keepAlive: false,
    },
  },
  {
    path: '/myActivity/signUp',
    name: 'signUp',
    component: () => import('@/sub-app/myActivity/pages/signUp.vue'),
    meta: {
      title: '填写报名信息',
      keepAlive: false,
    },
  },
  {
    path: '/myActivity/signUpSuccess',
    name: 'signUpSuccess',
    component: () => import('@/sub-app/myActivity/pages/signUpSuccess.vue'),
    meta: {
      title: '确认报名信息',
      keepAlive: false,
      isSignUpSuccess: true,
    }
  },
  {
    path: '/myActivity/signIn/:parkId/:id/:conId',
    name: 'signIn',
    component: () => import('@/sub-app/myActivity/pages/signIn.vue'),
    meta: {
      title: '签到',
      keepAlive: false
    }
  },
  {
    path: '/myActivity/newSignUp/:parkId/:id/:conId',
    name: 'newSignUp',
    component: () => import('@/sub-app/myActivity/pages/signUpNew.vue'),
    meta: {
      title: '报名',
      keepAlive: false
    }
  },
  // {
  //   path: '/myActivity/ticketDetail',
  //   name: 'ticketDetail',
  //   component: () => import('@/sub-app/myActivity/pages/ticketDetail.vue'),
  //   meta: {
  //     title: '活动列表',
  //     keepAlive: false,
  //   }
  // }
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 设置webview标题  
  document.title = to.meta?.title || '';

  // 检查是否试图访问报名成功页面  
  if ((from.name === 'myActivity' || from.name === 'myActivityFocus') && myActivity.state.isSignUpSuccess && to.name !== 'details') {
    // 如果是app
    try {
      window.yc.closeWeb()
    } catch (error) {
      console.log(error);
      next();
    }
  } else if (to.path !== '/myActivity/details' && to.query.parkId && to.query.conId &&  from.name != 'details') {
    localStorage.setItem('conId', to.query.conId)
    const options = to.query;
    console.log('aaaa', window.location.href);
    console.log('ddd', options);
    next({
      name: 'details',
      query: options, // 这里将 options 作为 query 参数传递给 details
      replace: true
    });
  } else {
    next();
  }
  next();
});

export default router;
